/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 * 
 * @export
 * @interface HotelChatRequest
 */
export interface HotelChatRequest {
    /**
     * The search session ID to load hotel results from.
     * @type {string}
     * @memberof HotelChatRequest
     */
    searchSessionId: string;
    /**
     * Optional freeform question about the hotels. When provided, the LLM answers this question in the context of the search results instead of generating a standard comparison.
     * @type {string}
     * @memberof HotelChatRequest
     */
    question?: string | null;
    /**
     * Explicit hotel selection (Compare These). When provided, only these hotels are compared and pre-filtering is skipped. Values are vervotech_property_ids.
     * @type {Array<number>}
     * @memberof HotelChatRequest
     */
    hotelIds?: Array<number> | null;
    /**
     * Prior messages in the conversation for multi-turn context.
     * @type {Array<ChatMessage>}
     * @memberof HotelChatRequest
     */
    conversationHistory?: Array<ChatMessage> | null;
}

/**
 * Check if a given object implements the HotelChatRequest interface.
 */
export function instanceOfHotelChatRequest(value: object): value is HotelChatRequest {
    if (!('searchSessionId' in value) || value['searchSessionId'] === undefined) return false;
    return true;
}

export function HotelChatRequestFromJSON(json: any): HotelChatRequest {
    return HotelChatRequestFromJSONTyped(json, false);
}

export function HotelChatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelChatRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'searchSessionId': json['search_session_id'],
        'question': json['question'] == null ? undefined : json['question'],
        'hotelIds': json['hotel_ids'] == null ? undefined : json['hotel_ids'],
        'conversationHistory': json['conversation_history'] == null ? undefined : ((json['conversation_history'] as Array<any>).map(ChatMessageFromJSON)),
    };
}

export function HotelChatRequestToJSON(json: any): HotelChatRequest {
    return HotelChatRequestToJSONTyped(json, false);
}

export function HotelChatRequestToJSONTyped(value?: HotelChatRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_session_id': value['searchSessionId'],
        'question': value['question'],
        'hotel_ids': value['hotelIds'],
        'conversation_history': value['conversationHistory'] == null ? undefined : ((value['conversationHistory'] as Array<any>).map(ChatMessageToJSON)),
    };
}

